import type { PropsWithChildren } from 'react';

import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

import { queryDefaults } from '@/shared/cache/queryDefaults';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      gcTime: queryDefaults.gcTimeMs,
      refetchOnWindowFocus: false,
      retry: 1,
      staleTime: queryDefaults.staleTimeMs,
    },
  },
});

export function QueryProvider({ children }: PropsWithChildren): React.JSX.Element {
  return <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>;
}
